import axios from "axios";
import { TTP_API_URL } from "Config";
import { updateSourceToken } from 'utils';
import { showErrorNotification } from "../../services/utils";

let getEventStatsDataTableSourceToken;
let countAppTypeEventsSourceToken;
let globalStatsSourceToken;
let seasonsSourceToken;
let fetchOrderSourceToken;
let fetchOrderSourceTokenForComparison;
let fetchBudgetDataSourceToken;

export const getEventStatsDataTable = (token, params = {}, sourceToken = null) => {

  getEventStatsDataTableSourceToken = updateSourceToken(getEventStatsDataTableSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document/get-event-or-cycle-infos`;

  const year = params.year ? params.year : [];
  const issuerId = params.issuerId ? params.issuerId : null;
  const appType = params.appType ? params.appType : null;
  const search = params.search ? params.search : '';
  const app = ['EVENT'];
  const start = params.start ? params.start : 0;
  const limit = params.limit ? params.limit : null;
  const lang = params.lang ? params.lang : null;
  const startMonth = params.startMonth ? params.startMonth : null;
  const endMonth = params.endMonth ? params.endMonth : null;
  const season = params.season ? params.season : null;
  const activitiesOrder = params.activitiesOrder ? params.activitiesOrder : null;

  return axios.get(requestUrl, {
    cancelToken: getEventStatsDataTableSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      app,
      year,
      appType,
      search,
      start,
      limit,
      lang,
      startMonth,
      endMonth,
      season,
      activitiesOrder
    }
  })
};


export const countEventAppType = (token, params = {}, sourceToken) => {

  countAppTypeEventsSourceToken = updateSourceToken(countAppTypeEventsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document/get-count-by-app-type`;

  const year = params.year ? params.year : [];
  const issuerId = params.issuerId ? params.issuerId : null;
  const search = params.search ? params.search : '';
  const app = ['EVENT'];
  const lang = params.lang ? params.lang : null;
  const startMonth = params.startMonth ? params.startMonth : null;
  const endMonth = params.endMonth ? params.endMonth : null;
  const season = params.season ? params.season : null;

  return axios.get(requestUrl, {
    cancelToken: countAppTypeEventsSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      app,
      year,
      search,
      lang,
      startMonth,
      endMonth,
      season

    }
  })
};

export const getGlobalEventStats = (token, params = {}, sourceToken) => {

  globalStatsSourceToken = updateSourceToken(globalStatsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document/get-infos-by-app-type`;

  const year = params.year ? params.year : [];
  const issuerId = params.issuerId ? params.issuerId : null;
  const app = ['EVENT'];
  const startMonth = params.startMonth ? params.startMonth : null;
  const endMonth = params.endMonth ? params.endMonth : null;
  const season = params.season ? params.season : null;

  return axios.get(requestUrl, {
    cancelToken: globalStatsSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      app,
      year,
      startMonth,
      endMonth,
      season,
    }
  })
};


export const getSeasonsValues = (token, params = {}, sourceToken) => {

  seasonsSourceToken = updateSourceToken(seasonsSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document/get-available-seasons`;

  const year = params.year ? params.year : [];
  const issuerId = params.issuerId ? params.issuerId : null;

  return axios.get(requestUrl, {
    cancelToken: seasonsSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      year,
    }
  })
};


export const fetchRegistrantLineChartData = (token, issuerId, frequency, period, languages, sourceToken = null, isComparison = 0, isComparisonDaily = 0) => {
  if (isComparison == 1) {
    fetchOrderSourceTokenForComparison = updateSourceToken(fetchOrderSourceTokenForComparison, sourceToken);
  } else {
    fetchOrderSourceToken = updateSourceToken(fetchOrderSourceToken, sourceToken);
  }

  const requestUrl = `${TTP_API_URL}/billing/document/get-inscriptions-stats`;

  return axios.get(requestUrl, {
    cancelToken: isComparison ? fetchOrderSourceTokenForComparison.token : fetchOrderSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      frequency,
      period,
      languages,
      isComparison,
      isComparisonDaily
    }
  })

};

export const fetchRegistrantLineChartCAData = (token, issuerId, frequency, period, languages, sourceToken = null, isComparison = 0, isComparisonDaily = 0) => {
  if (isComparison == 1) {
    fetchOrderSourceTokenForComparison = updateSourceToken(fetchOrderSourceTokenForComparison, sourceToken);
  } else {
    fetchOrderSourceToken = updateSourceToken(fetchOrderSourceToken, sourceToken);
  }

  const requestUrl = `${TTP_API_URL}/billing/document/get-ca-stats`;

  return axios.get(requestUrl, {
    cancelToken: isComparison ? fetchOrderSourceTokenForComparison.token : fetchOrderSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      frequency,
      period,
      languages,
      isComparison,
      isComparisonDaily
    }
  })
};


export const fetchCongressesDetails = (token, params = {}, sourceToken = null) => {

  getEventStatsDataTableSourceToken = updateSourceToken(getEventStatsDataTableSourceToken, sourceToken);

  const requestUrl = `${TTP_API_URL}/billing/document/get-congress-stats`;

  const year = params.year ? params.year : [];
  const issuerId = params.issuerId ? params.issuerId : null;
  const start = params.start ? params.start : 0;
  const limit = params.limit ? params.limit : null;
  const season = params.season ? params.season : null;
  const search = params.search ? params.search : '';

  return axios.get(requestUrl, {
    cancelToken: getEventStatsDataTableSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      year,
      season,
      start,
      limit,
      search,
    }
  })
};

export const deleteCacheForEventStats = (token) => {
  const requestUrl = TTP_API_URL + `/billing/document/delete-cache-for-event-stats`;

  var formData = new FormData();
  formData.append('access_token', token);

  return axios.post(requestUrl, formData);
};

export const getCacheOldestEntryPeriodForEventStats = (token) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-cache-oldest-entry-time-for-event-stats`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
    }
  })
};

export const fetchCycleTrainings = (token, cycleId, issuerId, year) => {

  const requestUrl = `${TTP_API_URL}/billing/document/get-cycle-formations`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      id: cycleId,
      issuerId,
      year,
    }
  })
};

export const fetchBudgetData = (token, issuerId, year, appType, sourceToken = null) => {
  fetchBudgetDataSourceToken = updateSourceToken(fetchBudgetDataSourceToken, sourceToken);
  const requestUrl = `${TTP_API_URL}/billing/global-budget-configuration/get-budget-details`;

  const appTypes = {
    'registering': 'formation',
    'cycle': 'cycle',
    'cycle_essential': 'cycle_essential',
    'all_in': 'season',
    'premium': 'premium',
    'monthly_premium': 'monthly_premium',
    'congres': 'congress',
    'all': 'all'
  }

  return axios.get(requestUrl, {
    cancelToken: fetchBudgetDataSourceToken.token,
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      year,
      appType: appTypes[appType]
    }
  })
};

export const generateFollowUp = (token, issuerId, appType, year, budgetPerMonth, globalTotalHTVA, globalRegistrantsCount, pricePerUnit) => {
  let requestUrl = `${TTP_API_URL}/billing/global-budget-configuration/generate-follow-up`;

  const appTypes = {
    'registering': 'formation',
    'cycle': 'cycle',
    'cycle_essential': 'cycle_essential',
    'all_in': 'season',
    'premium': 'premium',
    'monthly_premium': 'monthly_premium',
    'congres': 'congress',
    'all': 'all'
  }
  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('issuerId', issuerId);
  formData.append('appType', appTypes[appType]);
  formData.append('year', year);

  budgetPerMonth.forEach((item, index) => {
    let itemCopy = Object.assign({}, item);
    itemCopy.totalHTVA = itemCopy.totalHTVA * 100;
    formData.append(`budgetPerMonth[${index}]`, JSON.stringify(itemCopy));
  });

  formData.append('globalTotalHTVA', globalTotalHTVA * 100);
  formData.append('globalRegistrantsCount', globalRegistrantsCount);
  formData.append('pricePerUnit', pricePerUnit * 100);

  return axios.post(requestUrl, formData);
};

export const updateFollowUp = (token, annualTargetId, followUp) => {
  let requestUrl = `${TTP_API_URL}/billing/global-budget-configuration/update-follow-up`;

  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('globalBudgetConfigurationId', annualTargetId);
  followUp.forEach((item, index) => {
    let itemCopy = Object.assign({}, item);
    itemCopy.totalHTVA = itemCopy.totalHTVA * 100;
    itemCopy.realizedHTVA = itemCopy.realizedHTVA * 100;
    itemCopy.followUpPricePerUnit = itemCopy.followUpPricePerUnit * 100;
    formData.append(`followUp[${index}]`, JSON.stringify(itemCopy));
  });

  return axios.post(requestUrl, formData);
};

export const checkAppTypesConfiguration = (token, issuerId, year) => {
  const requestUrl = `${TTP_API_URL}/billing/global-budget-configuration/get-global-budget-configuration`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      year
    }
  })
};


export const deleteBudgetConfiguration = (token, annualTargetId, issuerId, year, appType) => {
  const appTypes = {
    'registering': 'formation',
    'cycle': 'cycle',
    'cycle_essential': 'cycle_essential',
    'all_in': 'season',
    'premium': 'premium',
    'monthly_premium': 'monthly_premium',
    'congres': 'congress',
    'all': 'all'
  }
  const requestUrl = `${TTP_API_URL}/billing/global-budget-configuration/remove-budget-details`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      globalBudgetConfigurationDetail: annualTargetId,
      issuerId,
      year,
      appType: appTypes[appType],
    }
  })
};

export const updateConfiguration = (token, annualTargetId, followUp, globalRegistrantsCount, pricePerUnit, globalTotalHTVA, budgetPerMonth) => {

  let requestUrl = `${TTP_API_URL}/billing/global-budget-configuration/update-budget-configuration`;

  var formData = new FormData();
  formData.append('access_token', token);
  formData.append('globalBudgetConfigurationId', annualTargetId);
  followUp.forEach((item, index) => {
    let itemCopy = Object.assign({}, item);
    itemCopy.totalHTVA = itemCopy.totalHTVA * 100;
    itemCopy.realizedHTVA = itemCopy.realizedHTVA * 100;
    itemCopy.followUpPricePerUnit = itemCopy.followUpPricePerUnit * 100;
    formData.append(`followUp[${index}]`, JSON.stringify(itemCopy));
  });

  formData.append('globalRegistrantsCount', globalRegistrantsCount);
  formData.append('pricePerUnit', pricePerUnit * 100);
  formData.append('globalTotalHTVA', globalTotalHTVA * 100);

  budgetPerMonth.forEach((item, index) => {
    let itemCopy = Object.assign({}, item);
    itemCopy.totalHTVA = itemCopy.totalHTVA * 100;
    formData.append(`budgetPerMonth[${index}]`, JSON.stringify(itemCopy));
  });

  return axios.post(requestUrl, formData);
};

export const startCommandGetCANbrInscriptionByFormat = (token, issuerId, frequency, period, languages) => {
  const requestUrl = `${TTP_API_URL}/billing/document/start-command-ca-nbr-inscrit-by-format`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      frequency,
      period,
      languages
    }
  })

};

export const startCommandCumulateByFormat = (token, issuerId, period, frequency, languages, type) => {
  const requestUrl = `${TTP_API_URL}/billing/document/start-command-cumulate-by-format`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      period,
      frequency,
      languages,
      type
    }
  })
};

export const getNbrCotisants = (token, period) => {
  const requestUrl = `${TTP_API_URL}/billing/assignment/get-nbr-cotisants`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      year: period
    }
  })
};

export const getActivePremium = (token, issuerId, period, frequency, startMonth, endMonth) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-active-premium`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      issuerId,
      period,
      frequency,
      startMonth,
      endMonth
    }
  })
}

export const getTypeFormats = (token, period) => {
  const requestUrl = `${TTP_API_URL}/billing/assignment/get-type-formats`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      year: period
    }
  })
}

export const getNbrCotisantByFormat = (token, period, frequency, month) => {
  const requestUrl = `${TTP_API_URL}/billing/assignment/get-nbr-cotisant-by-format`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      year: period,
      frequency,
      month
    }
  })
};

export const getCAByFormat = (token, period, frequency, month) => {
  const requestUrl = `${TTP_API_URL}/billing/assignment/get-ca-by-format`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      year: period,
      frequency,
      month
    }
  })
};

export const getCotisationMonths = (token, period) => {
  const requestUrl = `${TTP_API_URL}/billing/assignment/get-cotisation-months`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      year: period
    }
  })
};

export const getMembershipAssociative = (token, period, frequency, month) => {
  const requestUrl = `${TTP_API_URL}/billing/assignment/get-membership-associative`;

  return axios.get(requestUrl, {
    headers: { 'Accept': 'application/json,app=STATS_BILLING' },
    params: {
      access_token: token,
      year: period,
      frequency,
      month
    }
  })
}

export const getAccumulateStats = (token, period, frequency, month, type) => {
  const requestUrl = `${TTP_API_URL}/billing/assignment/get-accumulate-stats`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      year: period,
      frequency,
      month,
      type
    }
  })
};

export const getAccumulateEventStats = (token, issuerId, frequency, period, languages, type) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-accumulate-stats`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      issuerId,
      frequency,
      period,
      languages,
      type
    }
  })
};

export const deleteCacheForCotisationStats = (token) => {
  const requestUrl = TTP_API_URL + `/billing/document/delete-cache-for-cotisation-stats`;

  var formData = new FormData();
  formData.append('access_token', token);

  return axios.post(requestUrl, formData);
};

export const getCacheOldestEntryPeriodForCotisationStats = (token) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-cache-oldest-entry-time-for-cotisation-stats`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
    }
  })
};

export const getNbrInscritsCAPaperByRegion = (token, period) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-nbr-inscrits-ca-paper-region`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      year: period
    }
  })
};

export const getRapportInscritsPaper = (token, period) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-rapport-inscrits-paper`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      year: period
    }
  })
};

export const getRapportCAPaper = (token, period) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-rapport-ca-paper`;
  
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      year: period
    }
  })
};

export const startCommandGetNbrCaPaperByFrequency = (token, period, frequency, issuerId, month, userId) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-nbr-ca-paper-by-frequency`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      year: period,
      frequency,
      issuerId,
      month,
      userId
    }
  })
};

export const startCommandGetNbrInscritBySilot = (token, period, issuerId, userId) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-nbr-inscrit-by-silot`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      year: period,
      issuerId,
      userId
    }
  })
};

export const startCommandGetSilotDetails = (token, silotId, period, issuerId, userId) => {
  const requestUrl = `${TTP_API_URL}/billing/document/get-silot-details`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      silotId,
      year: period,
      issuerId,
      userId
    }
  })
};

export const getParticipantsStatsAction = (token, clientId) => {
  const requestUrl = `${TTP_API_URL}/event/user-slot-participation/participants-stats`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      clientId,
    }
  })
}


// WEBPACK FOOTER //
// ./app/api/TamtamAPI/eventStats.js